angular.module('zc.projects')

.directive 'graphDimensionSelect', ($timeout) ->
  return {
    restrict: 'A'
    require: ['?dimension', '?onUpdate']
    scope: {
      dimension: "=dimension"
      onUpdate: "&onUpdate"
    }
    templateUrl: '/templates/projects.campaigns/views/directives/graph_dimension_select.html'
    link: (scope, elem, attrs) ->
      scope.dimension = 'daily' if !scope.dimension

      scope.setDimension = (dim) ->
        scope.dimension = dim
        #if !$scope.$$phase
        $timeout () ->
          scope.$apply()
          scope.onUpdate()
  }




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/graph_dimension_select.js.coffee